module.exports = __webpack_public_path__ + "static/media/proj2_img2.9602e99e.jpg";